<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column prop="Xm" label="游客姓名"> </el-table-column>
        <el-table-column
          prop="Sjhm"
          label="手机号码"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Zjlx"
          label="证件类型"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Zjh"
          label="证件号"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Xb"
          label="性别"
          :formatter="$tab_StatusFormat"
        />
        <el-table-column
          prop="Csrq"
          label="出生日期"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="HmdYy"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="280"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="onOpenCompile(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_YouKe_Hmd_编辑')
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_YouKe_Hmd_删除')
              "
              >删除
            </el-button>
            <el-button
              type="warning"
              :icon="Close"
              link
              @click="onXiBai(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_YouKe_Hmd_移除')
              "
              >移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="state.compileTitle + '游客'"
        @close="onCloseCompile(false)"
      >
        <c_compile
          @close="onCloseCompile(true)"
          :id="state.selectId"
        ></c_compile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { youke_list, youke_delete, youke_xibai } from "@/http/api";
import { ElMessageBox, ElMessage } from "element-plus";

import c_compile from "./Compile.vue";
export default {
  components: {
    c_compile,
  },
  setup() {
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: { IsHmd: true, TableName: "YouKe_Hmd" },
        Order: "Cjsj",
        Asc: false,
      },
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      youke_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //打开内容页
    const onOpenCompile = (id) => {
      state.compileTitle = id ? "修改" : "添加";
      state.selectId = id;
      state.showCompile = true;
    };

    //关闭内容页
    const onCloseCompile = (refresh) => {
      state.showCompile = false;
      if (refresh) {
        onLoad();
      }
    };

    //排序
    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Cjsj",
          Asc: false,
        },
      });
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      ElMessageBox.confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        youke_delete(id).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert("删除成功", "提示", {
              type: "success",
              callback: () => {
                onLoad();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    const onXiBai = (id) => {
      ElMessageBox.confirm("您确定将该游客移除黑名单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        youke_xibai(id).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data);
            onLoad();
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onCloseCompile,
      onOpenCompile,
      onDelete,
      onXiBai,
    };
  },
};
</script>
<style>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>
